import { apiFetch } from "./client";
import type {
  ClientiListResponse,
  CommissioniResponse,
  ContrattiListResponse,
  DashboardAffiliatoResponse,
  OperatoriResponse,
  PipelineResponse,
  SerieResponse,
} from "@/types";

export async function getDashboardAffiliato(): Promise<DashboardAffiliatoResponse> {
  return apiFetch<DashboardAffiliatoResponse>("/espo/affiliato/dashboard");
}

export async function getContrattiAffiliato(params: {
  limit?: number;
  offset?: number;
  stage?: string | null;
}): Promise<ContrattiListResponse> {
  const q = new URLSearchParams();
  q.set("limit", String(params.limit ?? 20));
  q.set("offset", String(params.offset ?? 0));
  if (params.stage) q.set("stage", params.stage);
  return apiFetch<ContrattiListResponse>(`/espo/affiliato/contratti?${q.toString()}`);
}

export async function getCommissioniAffiliato(from: string, to: string): Promise<CommissioniResponse> {
  const q = new URLSearchParams({ from, to });
  return apiFetch<CommissioniResponse>(`/espo/affiliato/commissioni?${q}`);
}
export async function getCommissioniSerie(from: string, to: string): Promise<SerieResponse> {
  return apiFetch<SerieResponse>(`/espo/affiliato/commissioni/serie?${new URLSearchParams({ from, to })}`);
}
export async function getCommissioniOperatori(from: string, to: string): Promise<OperatoriResponse> {
  return apiFetch<OperatoriResponse>(`/espo/affiliato/commissioni/operatori?${new URLSearchParams({ from, to })}`);
}
export async function getCommissioniPipeline(from: string, to: string): Promise<PipelineResponse> {
  return apiFetch<PipelineResponse>(`/espo/affiliato/commissioni/pipeline?${new URLSearchParams({ from, to })}`);
}

export async function getClientiAffiliato(params: {
  limit?: number;
  offset?: number;
  q?: string;
}): Promise<ClientiListResponse> {
  const qs = new URLSearchParams();
  qs.set("limit", String(params.limit ?? 20));
  qs.set("offset", String(params.offset ?? 0));
  if (params.q) qs.set("q", params.q);
  return apiFetch<ClientiListResponse>(`/espo/affiliato/clienti?${qs.toString()}`);
}
